import React, { useState } from 'react';
import { md, isBlankBlock } from '../utils/markdown';

const PlaceSection = () => {
  const [selectedCategory, setSelectedCategory] = useState('');
  const [results, setResults] = useState('');

  const PLACE_API_URL = 'https://8x1vrwj132.execute-api.ap-northeast-2.amazonaws.com/place/genai-place-api';

  const categories = ['약국', '병원', '편의점', '영화관', '카페', '은행'];

  // 카테고리를 3개씩 그룹으로 나누는 함수
  const chunkArray = (array, size) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += size) {
      chunks.push(array.slice(i, i + size));
    }
    return chunks;
  };

  const categoryGroups = chunkArray(categories, 3);

  const getCurrentPosition = () => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error('위치 정보가 지원되지 않습니다.'));
      }

      navigator.geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      });
    });
  };

  const handleCategoryClick = async (category) => {
    setSelectedCategory(category);
    setResults('위치 정보를 확인하는 중입니다...');

    try {
      const position = await getCurrentPosition();
      const { latitude, longitude } = position.coords;

      setResults(`주변 '${category}' 정보를 가져오는 중입니다...`);

      const response = await fetch(PLACE_API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          category,
          latitude,
          longitude
        }),
      });

      if (response.ok) {
        const data = await response.json();
        const formattedResults = data.recommendations
          .split('\n\n')
          .filter(p => !isBlankBlock(p))
          .map(p => `<div class="analysis-paragraph">${md(p.trim())}</div>`)
          .join('');

        setResults(`
          <h3>📍 현재 위치 기준 '${category}' 검색 결과</h3>
          <div class="analysis-content">
            ${formattedResults}
          </div>
        `);
      } else {
        const errorData = await response.json();
        setResults(`에러 발생: ${errorData.message}`);
      }
    } catch (error) {
      console.error('주변 시설 찾기 오류:', error);
      if (error.message.includes('위치 정보')) {
        setResults('위치 정보 접근이 거부되었습니다. 위치 정보 접근을 허용해주세요.');
      } else {
        setResults(`서버와 통신 중 오류가 발생했습니다: ${error.message}`);
      }
    }
  };

  return (
    <section className="service-section">
      <h2>주변 시설 찾기 서비스</h2>
      <p className="info-text">(위치 기반 추천)</p>
      {categoryGroups.map((categoryGroup, groupIndex) => (
        <div key={groupIndex} className="button-container" style={{ marginTop: groupIndex > 0 ? '15px' : '0' }}>
          {categoryGroup.map(category => (
            <button
              key={category}
              className={`category-btn ${selectedCategory === category ? 'selected' : ''}`}
              onClick={() => handleCategoryClick(category)}
            >
              {category}
            </button>
          ))}
        </div>
      ))}
      {results && <div className="results" dangerouslySetInnerHTML={{ __html: results }}></div>}
    </section>
  );
};

export default PlaceSection;